/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  SettleLeverageAccruedInterestOptions,
  SettleLeverageAccruedInterestStatus200,
  SettleLeverageAccruedInterestStatus400,
  SettleLeverageAccruedInterestStatus401,
  SettleLeverageAccruedInterestStatus500,
} from '../types/SettleLeverageAccruedInterest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { settleLeverageAccruedInterest } from '../clients/settleLeverageAccruedInterest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const settleLeverageAccruedInterestMutationKey = () =>
  [{ url: '/v1/leverage/accrued_interest/settle' }] as const

export function settleLeverageAccruedInterestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = settleLeverageAccruedInterestMutationKey()
  return mutationOptions<
    SettleLeverageAccruedInterestStatus200,
    ResponseErrorConfig<
      | SettleLeverageAccruedInterestStatus400
      | SettleLeverageAccruedInterestStatus401
      | SettleLeverageAccruedInterestStatus500
    >,
    SettleLeverageAccruedInterestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return settleLeverageAccruedInterest({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Settle current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/settle}
 */
export function useSettleLeverageAccruedInterest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SettleLeverageAccruedInterestStatus200,
      ResponseErrorConfig<
        | SettleLeverageAccruedInterestStatus400
        | SettleLeverageAccruedInterestStatus401
        | SettleLeverageAccruedInterestStatus500
      >,
      SettleLeverageAccruedInterestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? settleLeverageAccruedInterestMutationKey()

  const baseOptions = settleLeverageAccruedInterestMutationOptions(config) as UseMutationOptions<
    SettleLeverageAccruedInterestStatus200,
    ResponseErrorConfig<
      | SettleLeverageAccruedInterestStatus400
      | SettleLeverageAccruedInterestStatus401
      | SettleLeverageAccruedInterestStatus500
    >,
    SettleLeverageAccruedInterestOptions,
    TContext
  >

  return useMutation<
    SettleLeverageAccruedInterestStatus200,
    ResponseErrorConfig<
      | SettleLeverageAccruedInterestStatus400
      | SettleLeverageAccruedInterestStatus401
      | SettleLeverageAccruedInterestStatus500
    >,
    SettleLeverageAccruedInterestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    SettleLeverageAccruedInterestStatus200,
    ResponseErrorConfig<
      | SettleLeverageAccruedInterestStatus400
      | SettleLeverageAccruedInterestStatus401
      | SettleLeverageAccruedInterestStatus500
    >,
    SettleLeverageAccruedInterestOptions,
    TContext
  >
}
